import React from "react";
import { useTranslation } from "react-i18next";
import Mssql from "./kardex/mssql";
import WebServices from "./kardex/webServices";

/**
 * Renders the Kardex settings component.
 *
 * @returns {JSX.Element} The rendered settings component.
 */
export default function Kardex() {
  const { t } = useTranslation();
  return (
    <div>
      <h1>{t("translation:kardex_settings")}</h1>
      <Mssql />
      <WebServices />
    </div>
  );
}
